import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/common/ProtectedRoute';

// Pages
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import LearnerDashboard from '../pages/dashboards/LearnerDashboard';
import MyLearningPage from '../pages/learner/MyLearningPage';
import CourseDetailPage from '../pages/learner/CourseDetailPage';
import CourseBrowsePage from '../pages/learner/CourseBrowsePage';
import BadgesPage from '../pages/learner/BadgesPage';
import LearnerPublications from '../pages/learner/LearnerPublications';
import QuizPage from '../pages/learner/QuizPage';
import QuizReviewPage from '../pages/learner/QuizReviewPage';
import ProfilePage from '../pages/learner/ProfilePage';
import ParentDashboard from '../pages/dashboards/ParentDashboard';
import StudentsPage from '../pages/parent/StudentsPage';
import LearningIntelligencePage from '../pages/parent/LearningIntelligencePage';
import PerformancePage from '../pages/parent/PerformancePage';
import EngagementPage from '../pages/parent/EngagementPage';
import ROIPage from '../pages/parent/ROIPage';
import ComparativePage from '../pages/parent/ComparativePage';
import InsightsPage from '../pages/parent/InsightsPage';
import TeacherRoutes from '../pages/teacher/TeacherRoutes';
import PublisherRoutes from '../pages/publisher/PublisherRoutes';
import AdminDashboard from '../pages/dashboards/AdminDashboard';
import OwnerDashboard from '../pages/dashboards/OwnerDashboard';
import OwnerRevenuePage from '../pages/owner/RevenuePage';
import OwnerUsersPage from '../pages/owner/UsersPage';
import OwnerContentPage from '../pages/owner/ContentPage';
import OwnerEngagementPage from '../pages/owner/EngagementPage';
import OwnerFunnelPage from '../pages/owner/FunnelPage';
import OwnerInsightsPage from '../pages/owner/InsightsPage';

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      
      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Protected Routes - Student (Learner) */}
      <Route
        path="/learner"
        element={
          <ProtectedRoute requiredRole="student">
            <LearnerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/courses"
        element={
          <ProtectedRoute requiredRole="student">
            <MyLearningPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/browse"
        element={
          <ProtectedRoute requiredRole="student">
            <CourseBrowsePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/publications"
        element={
          <ProtectedRoute requiredRole="student">
            <LearnerPublications />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/progress"
        element={
          <ProtectedRoute requiredRole="student">
            <MyLearningPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/badges"
        element={
          <ProtectedRoute requiredRole="student">
            <BadgesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/courses/:courseId"
        element={
          <ProtectedRoute requiredRole="student">
            <CourseDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/quiz/:quizId"
        element={
          <ProtectedRoute requiredRole="student">
            <QuizPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/quiz/:quizId/review/:quizAttemptId"
        element={
          <ProtectedRoute requiredRole="student">
            <QuizReviewPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/learner/profile"
        element={
          <ProtectedRoute requiredRole="student">
            <ProfilePage />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Parent */}
      <Route
        path="/parent"
        element={
          <ProtectedRoute requiredRole="parent">
            <ParentDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/students"
        element={
          <ProtectedRoute requiredRole="parent">
            <StudentsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/learning-intelligence"
        element={
          <ProtectedRoute requiredRole="parent">
            <LearningIntelligencePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/performance"
        element={
          <ProtectedRoute requiredRole="parent">
            <PerformancePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/engagement"
        element={
          <ProtectedRoute requiredRole="parent">
            <EngagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/roi"
        element={
          <ProtectedRoute requiredRole="parent">
            <ROIPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/comparative"
        element={
          <ProtectedRoute requiredRole="parent">
            <ComparativePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/parent/insights"
        element={
          <ProtectedRoute requiredRole="parent">
            <InsightsPage />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Teacher */}
      <Route
        path="/teacher/*"
        element={
          <ProtectedRoute requiredRole="teacher">
            <TeacherRoutes />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Publisher */}
      <Route
        path="/publisher/*"
        element={
          <ProtectedRoute requiredRole="publisher">
            <PublisherRoutes />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Admin */}
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute requiredRole="admin">
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Owner */}
      <Route
        path="/owner"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/revenue"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerRevenuePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/users"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerUsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/content"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerContentPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/engagement"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerEngagementPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/funnel"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerFunnelPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/owner/insights"
        element={
          <ProtectedRoute requiredRole="owner">
            <OwnerInsightsPage />
          </ProtectedRoute>
        }
      />

      {/* 404 - Not Found */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;

